<template>
  <div v-if="item" class="item-description">
    <div class="description-title" v-bind:class="{ 'description-title-bold': largeTitle }">{{item.name}}</div>
    <div>{{item.description}}</div>
    <div class="item-number">
      Item # {{item.id}}
      <span v-if="orderInfo" class="item-order">, {{item.quantity}} Qty @ {{item.price | currency}} Ea</span>
    </div>
    <detail-modal :item="item">Details</detail-modal>
  </div>
</template>

<style lang="sass" scoped>
  .description-title
    font-size: 16px
    font-weight: 600
    text-transform: capitalize
  .description-title-bold
    font-size: 20px
    margin-bottom: 16px
</style>

<script>
import DetailModal from '../widgets/detail-modal'

export default {
  components: {
    detailModal: DetailModal
  },

  props: {
    item: Object,
    largeTitle: { type: Boolean, default: false },
    orderInfo: { type: Boolean, default: false }
  }
}
</script>



// WEBPACK FOOTER //
// item-description.vue?175b4cac